import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import { useProcessPendingInvite } from '@/features/invites/hooks/useProcessPendingInvite';
import { usePromptNotificationPermission } from '@/features/notifications/hooks/usePromptNotificationPermission';
import { useAutoPromptFirstWave } from '@/features/onboarding/hooks/useAutoPromptFirstWave';
import { getMyProfileOptions } from '@/features/profile/hooks/useGetMyProfile/getMyProfile.options';
import { useMyUserId } from '@/features/users/hooks/useGetMyUser';
import { useConnectToStreamChat } from '@/integrations/getstream/chat-client';
import { StreamVideoProvider } from '@/integrations/getstream/stream-video-provider';
import { ProtectedModals } from '@/shared/components/protectedModals';

export const Route = createFileRoute('/_protected/_app')({
  component: AppLayout,
  beforeLoad: async ({ context }) => {
    const profile = await context.queryClient.ensureQueryData(
      getMyProfileOptions(),
    );

    if (!profile.profile) {
      throw redirect({ to: '/onboarding', replace: true });
    }

    // Prefetch Valorant data for rank status (used in NavBar)
    if (profile.profile.riotPuuid) {
      void context.queryClient.prefetchQuery(
        getValorantPlayerOptions({ puuid: profile.profile.riotPuuid }),
      );
    }
  },
});

function AppLayout() {
  const myUserId = useMyUserId();
  useConnectToStreamChat();
  useProcessPendingInvite(); // Must run before notification prompt so invite modal is in stack first
  usePromptNotificationPermission('newSession', true);
  useAutoPromptFirstWave();

  return (
    <StreamVideoProvider userId={myUserId}>
      <Outlet />
      <ProtectedModals />
    </StreamVideoProvider>
  );
}
